export default __webpack_public_path__ + "static/media/game.c6b5a69a.png";